import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'container',
    'stepsContainer',
    'bookingForm',
    'bookingFormFields',
    'bookingSummary',
    'product',
    'suggestions',
    'result',
    'mobileNav',
    'mobileNavItem',
    'heroImage',
    'stepSelected',
    'stepIndicator',
    'submitted',
  ]

  connect() {
    this.product = false
    this.bookingFormValid = false
    this.setSteps()

    window.addEventListener('scroll', (e) => this.onScroll(e), { passive: true })
    this.mobileStep = 0
  }
  toStep(e) {
    this.step = `step-${e.params.step}`
    sessionStorage.setItem('wizard-step', this.step)
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.setSteps()
  }
  onScroll() {
    if (window.innerWidth <= 600) {
      this.mobileNavTarget.style.transform =
        window.scrollY > 0 ? 'translateY(-65px)' : 'translateY(0px)'
      const positions = this.mobileNavItemTargets
        .filter((elem) => elem.getBoundingClientRect().height != 0)
        .map((linkElem) => {
          const elem = this.element.querySelector(linkElem.dataset.scrollElem)
          return elem.offsetTop
        })
        .filter((pos) => window.scrollY - 50 > pos)
      this.mobileStep = positions.length > 0 ? positions.length - 1 : 0
      this.step = `step-${[0, 1, 2].includes(this.mobileStep) ? 0 : this.mobileStep - 2}`
      this.setSteps()
    }
  }
  setSteps() {
    const steps = ['step-0', 'step-1', 'step-2', 'step-3']
    if (!this.step) {
      const defaultStep = this.bookingFormValid ? 'step-2' : this.product ? 'step-1' : 'step-0'
      this.step = defaultStep
      this.step = sessionStorage.getItem('wizard-step')
        ? sessionStorage.getItem('wizard-step')
        : defaultStep
    }
    this.mobileNavItemTargets.map((elem, i) => {
      elem.classList[i < this.mobileStep ? 'add' : 'remove']('above')
    })
    const bulletColor = this.mobileNavItemTargets[this.mobileStep]?.dataset.bulletColor
    this.stepSelectedTarget.style.transform = `translateY(${this.mobileStep * 34}px)`
    this.stepSelectedTarget.style.backgroundColor = bulletColor

    this.containerTarget.classList.remove(...steps)
    this.containerTarget.classList.add(this.step)

    this.stepIndicatorTargets.map((elem, i) => {
      elem.classList[`step-${i}` === this.step ? 'add' : 'remove']('selected')
    })

    this.setBookingFormValid()
    this.setStepButtons()
  }
  setBookingFormValid() {
    const requiredElements = this.bookingFormTarget.querySelectorAll(
      'input[required], select[required]'
    )
    const requiredValidElements = Array.from(requiredElements).filter((elem) => {
      return elem.type === 'checkbox' ? elem.checked : elem.value
    })
    this.bookingFormValid = requiredValidElements.length >= requiredElements.length
    this.containerTarget.classList[this.bookingFormValid ? 'add' : 'remove']('booking-form-valid')
    this.setHeroImageHeight()
  }
  setStepButtons() {
    ;[
      [
        Array.from(this.element.querySelectorAll('[data-wizard--manager-step-param="1"]')),
        this.product,
      ],
      [
        Array.from(this.element.querySelectorAll('[data-wizard--manager-step-param="2"]')),
        this.bookingFormValid,
      ],
      [
        Array.from(this.element.querySelectorAll('[data-wizard--manager-step-param="3"]')),
        this.step === 'step-2' || window.innerWidth <= 600,
      ],
    ].map((buttonSet) => {
      buttonSet[0].map((elem) => {
        elem.classList[buttonSet[1] ? 'remove' : 'add']('disabled')
        if (buttonSet[1]) {
          elem.removeAttribute('disabled')
        } else {
          elem.setAttribute('disabled', true)
        }
      })
    })
  }
  bookingSummaryTargetConnected() {
    this.setSteps()
    this.setBookingSummaryFields()
    this.setHeroImageHeight()
  }
  bookingFormFieldsTargetConnected() {
    this.restoreFormData()
    this.setSteps()
  }
  productTargetConnected() {
    this.product = true
    this.containerTarget.classList.add('booking-product')
    this.containerTarget.classList.add('has-result')
    this.setHeroImageHeight()
    this.setSteps()
  }
  productTargetDisconnected() {
    this.product = false
    this.containerTarget.classList.remove('booking-product')
    this.containerTarget.classList.remove('has-result')
    this.setHeroImageHeight()
    this.setSteps()
  }
  saveFormData() {
    Array.from(this.bookingFormTarget.elements).map((field) => {
      if (field.type === 'checkbox') {
        sessionStorage.setItem(field.name, field.checked)
      } else {
        sessionStorage.setItem(field.name, field.value)
      }
    })
  }
  restoreFormData() {
    Array.from(this.bookingFormTarget.elements).map((field) => {
      const storageFieldValue = sessionStorage.getItem(field.name)
      if (sessionStorage.getItem(field.name)) {
        if (field.type === 'checkbox') {
          field.checked = storageFieldValue === 'true'
        } else {
          field.value = storageFieldValue
        }
      }
    })
  }
  bookingFormChangeHandler() {
    this.saveFormData()
    this.setBookingSummaryFields()
    this.setSteps()
  }
  mobileLinkHandler(e) {
    const elem = this.element.querySelector(e.params.scrollElem)
    scrollTo({
      top: elem.offsetTop + 55,
      behavior: 'smooth',
    })
  }
  setBookingSummaryFields() {
    Array.from(this.bookingFormTarget.elements).map((field) => {
      const summaryElement = document.getElementById(`booking_form_field_${field.name}`)
      if (summaryElement) {
        if (field.type === 'checkbox') {
          summaryElement.textContent = field.checked ? 'Ja' : 'Nee'
        } else {
          summaryElement.textContent = field.value ? field.value : '-'
        }
      }
    })
  }
  submit() {
    Array.from(
      this.element.querySelectorAll(
        '[data-wizard--manager-step-param="1"], [data-wizard--manager-step-param="3"]'
      )
    ).map((elem) => {
      elem.style.visibility = 'hidden'
    })
    sessionStorage.removeItem('wizard-step')
    this.bookingFormTarget.requestSubmit()
  }
  submittedTargetConnected() {
    this.step = 'step-3'
    this.setSteps()
  }
  suggestionsTargetConnected(target) {
    this.containerTarget.classList.add('has-suggestions')
    this.element.querySelector('.booking-mobile-navigator__suggestions-text').textContent =
      target.dataset.mobileLabel
    this.setHeroImageHeight()
  }
  suggestionsTargetDisconnected() {
    this.containerTarget.classList.remove('has-suggestions')
    this.element.querySelector('.booking-mobile-navigator__suggestions-text').textContent = ''
    this.setHeroImageHeight()
  }
  resultTargetConnected(target) {
    this.containerTarget.classList.add('has-result')
    this.element.querySelector('.booking-mobile-navigator__result-text').textContent =
      target.dataset.name
    this.setHeroImageHeight()
  }
  resultTargetDisconnected() {
    const resultTextElem = this.element.querySelector('.booking-mobile-navigator__result-text')
    if (this.resultTargets.length === 0) {
      this.containerTarget.classList.remove('has-result')
      resultTextElem.textContent = ''
    } else {
      resultTextElem.textContent = this.resultTargets[this.resultTargets.length - 1].dataset.name
      this.containerTarget.classList.add('has-result')
    }
    this.setHeroImageHeight()
  }
  setHeroImageHeight() {
    setTimeout(() => {
      this.heroImageTarget.style.height = `${
        this.mobileNavTarget.getBoundingClientRect().height - 45
      }px`
    }, 1000)
  }
}
